import { render, staticRenderFns } from "./DefaulSuc.vue?vue&type=template&id=199d1108&scoped=true"
import script from "./DefaulSuc.vue?vue&type=script&lang=js"
export * from "./DefaulSuc.vue?vue&type=script&lang=js"
import style0 from "./DefaulSuc.vue?vue&type=style&index=0&id=199d1108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d1108",
  null
  
)

export default component.exports